import React from 'react';
import PropTypes from 'prop-types';
import MaterialNumberField from 'shared/components/connectedTextField/c/materialNumberField/MaterialNumberField';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RemoveIcon from '@material-ui/icons/Clear';
import { PERCENTAGE_OF_GROSS_RADIO_BUTTON, SELECT_ALLOCATION_UNIT_RADIO_BUTTON } from '../RadioButtonsConstants';

const styles = {
  radioButton: {
    marginBottom: 16,
  },
  inputStyle : { 
    display: 'block',
    width: '100%',
    fontSize: '12px'
  }
};
const textStyle = { fontSize: 12, color: textColorGray };

class ConfigureCostObject extends React.Component {

  constructor(props) {
    super(props);
    const { 
      costObject: {
        id,
        name,
        amount,
        percentageOfGross
      }
    } = props;
    this.state = { 
      costObject: {
        id,
        name,
        amount,
        percentageOfGross
      },
      pristineTextField: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if((this.props.allocationUnitId !== nextProps.allocationUnitId) || (this.props.radioButtonValue !== nextProps.radioButtonValue)){  
      this.setState({
        costObject: {  
          id: 0,
          name: '',
          amount: '',
          percentageOfGross: ''
        }
      }, () => {
        this.props.onCostObjsChange(this.state.costObject);
      });
    }

    if(this.props.costObject !== nextProps.costObject){
      const costObject = nextProps.costObject;
      this.setState( { costObject });
    }
  }

  handleSelectCostObjsChange = (ev, index, value) => {
    const selectedCostObj = this.props.costObjects.find( costObj => costObj.id === value );
    this.setState({
      costObject: {  
        id: value,
        name: value !== 0 ? selectedCostObj.name : '',
        amount: this.props.allocationUnitId !== 0 && value !== 0 ? selectedCostObj.amount : '',
        percentageOfGross: ''
      },
      pristineTextField: true
    }, () => {
      this.props.onCostObjsChange(this.state.costObject);
    });
    this.props.onSelectCostObject(this.state.costObject.id, value);
  };

  handleInputChange = (ev, value) => {
    const target = ev.target;
    const allocationId = this.props.allocationUnitId;
    this.setState(oldState => ({
      costObject: { ...oldState.costObject, 
        [target.name] : allocationId !== 0 ? value : '',
        percentageOfGross: allocationId !== 0 ? '' : value
      }
    }), () => {
      this.props.onCostObjsChange(this.state.costObject);
      this.props.onLastInputFieldSelected(this.state.costObject.id);
    });
  };

  handleRequiredAmount = () => this.setState(oldState => ({ ...oldState, pristineTextField: false }));

  handleRemoveAllocationUnit = () => {
    this.props.onRemoveCostObject();
  };

  render(){
    const { costObjects, radioButtonValue, fetchingCostObjects, allocationUnitId, showRemoveIcon, isPercentageOfGrossExceeded, lastInputFieldSelected } = this.props;
    const { costObject } = this.state;

    return(
      <div className="cost-object-container">
        <div className="cost-object-container__cost-object-dropdown">
          <SelectField
            name={ 'costObjectKey' }
            hintText= "Select Cost Object"
            style={ { width: 175 } }
            fullWidth={ true }
            maxHeight={ 400 }
            iconStyle={ { fill: disabledButtonTextGray } }
            hintStyle={ { ...textStyle, color: disabledButtonTextGray } }
            labelStyle={ textStyle }
            underlineStyle={ { borderColor: disabledButtonTextGray } }
            value={ costObject.id }
            onChange={ this.handleSelectCostObjsChange }
            disabled= { fetchingCostObjects || radioButtonValue === SELECT_ALLOCATION_UNIT_RADIO_BUTTON && allocationUnitId === 0 || costObjects.length === 0 }
          >
            <MenuItem value={ 0 } primaryText={ "Select Cost Object" } style={ { color: '#bcbcbc' } } />
            {              
              costObjects.map( costObject => (
                <MenuItem key={ costObject.id } value={ costObject.id } primaryText={ costObject.name } disabled={ costObject.disabled }/>
              ))
            }
          </SelectField>   
        </div>
        <div className="cost-object-container__unit-amount-field">
          <MaterialNumberField
            name={ 'amount' }
            label={ 'Unit Amount [or] XX %' } 
            value={ allocationUnitId !== 0 ? costObject.amount : costObject.percentageOfGross }
            onChange={ this.handleInputChange }
            fullWidth={ false }
            style={ styles.inputStyle }
            disabled={ radioButtonValue !== PERCENTAGE_OF_GROSS_RADIO_BUTTON || costObject.id === 0 }
            errorText= { costObject.percentageOfGross > 100 || isPercentageOfGrossExceeded && lastInputFieldSelected === costObject.id ? 'Total percentage cannot be greater than 100%' : '' }
            required={ (costObject.percentageOfGross === '' && costObject.id !== 0 && radioButtonValue === PERCENTAGE_OF_GROSS_RADIO_BUTTON) }
            pristineForm= { this.state.pristineTextField }
            onBlur={ this.handleRequiredAmount }
            isPercentageValue={ true }
          />              
        </div>
        {
          showRemoveIcon &&
          <RemoveIcon className="cost-obj-allocation-unit-container__label" style={ { cursor: 'pointer' } } onClick={ this.handleRemoveAllocationUnit }/>
        }
      </div>
    );
  }
}

ConfigureCostObject.propTypes = {
  costObject: PropTypes.object.isRequired,
  allocationUnitId: PropTypes.number.isRequired,
  fetchingCostObjects: PropTypes.bool,
  costObjects: PropTypes.array,
  radioButtonValue: PropTypes.string,
  onCostObjsChange: PropTypes.func.isRequired,
  showRemoveIcon: PropTypes.bool.isRequired,
  onRemoveCostObject: PropTypes.func.isRequired,
  onSelectCostObject: PropTypes.func.isRequired,
  isPercentageOfGrossExceeded: PropTypes.bool.isRequired,
  onLastInputFieldSelected: PropTypes.func.isRequired,
  lastInputFieldSelected: PropTypes.number.isRequired
};

export default ConfigureCostObject;




// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/comp/ConfigureCostObject.js